import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { InputGroup, FormControl } from 'react-bootstrap';
import * as actions from "../../../../app/actions/generalActions";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_themeBase/_partials/controls";
import { useSubheader } from "../../../../_themeBase/layout";
import { ModalProgressBar } from "../../../../_themeBase/_partials/controls";
import { FormattedMessage, useIntl } from "react-intl";

const PaymentResultPage = ({
    match: {
        params: { pid: id },
    }
}) => {
    // Subheader
    const suhbeader = useSubheader();

    const initObject = {
        id: undefined,
        userFullName: "",
        amount: 0,
        credit: 0,
        prevCredit: 0,
        bankAccountId: 0,
        bankAccountTitle: "",
        transactionTypeTitle: "",
        orderId: "",
        refrenceNumber: "",
        traceNumber: "",
        statusCode: "",
        timeStamp: "",
        reverifyTimeStamp: "",
        verifyingCode: "",
        result: false,
    };

    const intl = useIntl();
    const history = useHistory()
    const [title, setTitle] = useState(<div className="mt-8 ">{"نتیجه پرداخت اینترنتی"}</div>);
    const [paymentObject, setPaymentObject] = useState(initObject);
    const { currentState } = useSelector(
        (state) => ({ currentState: state.sport.sport_payment }),
        shallowEqual
    );


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchObject("api/EPayPayment", currentState.name, id));
    }, [id, dispatch]);

    useEffect(() => {
        if (currentState.objectForEdit) {
            setPaymentObject(currentState.objectForEdit)

            if (currentState.objectForEdit.result)
                setTitle(<div className="mt-8 text-success">{"تراکنش موفق"}</div>)
            else
                setTitle(<div className="mt-8 text-danger">{"تراکنش ناموفق"}</div>)
        }
    }, [currentState.objectForEdit]);

    const backToObjectsList = () => {
        dispatch(actions.fetchObject("api/EPayPayment", currentState.name, undefined))
        history.push("/dashboard");
    };

    return (
        <>

            <Card className="">
                {currentState.actionsLoading && <ModalProgressBar />}
                <CardHeader >
                    <div >
                        {title}
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "AUTH.INPUT.FULLNAME" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.userFullName}
                            </FormControl>
                        </InputGroup>
                    </div>



                    <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "MODULES.BASEINFO.USERS.EDITALL.TRANSACTIONTYPE" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.transactionTypeTitle}
                            </FormControl>
                        </InputGroup>
                    </div>

                    {/* <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.RESULT" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.statusCode}
                            </FormControl>
                        </InputGroup>
                    </div> */}

                    <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.ORDERID" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.orderId}
                            </FormControl>
                        </InputGroup>
                    </div>

                    <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.TRACENYMBER" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.traceNumber}
                            </FormControl>
                        </InputGroup>
                    </div>

                    <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.AMOUNT" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.amount !== undefined && paymentObject.amount !== null ? paymentObject.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0"}
                            </FormControl>
                            <InputGroup.Append>
                                <InputGroup.Text style={{ minWidth: "90px" }}>{"ریال"}</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </div>

                    {/* <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.PREVCREDIT" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.prevCredit}
                            </FormControl>
                            <InputGroup.Append>
                                <InputGroup.Text style={{ minWidth: "90px" }}>{"ریال"}</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </div> */}

                    {/* <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <InputGroup className=" mb-1">
                            <InputGroup.Prepend>
                                <InputGroup.Text style={{ minWidth: "180px" }}>{intl.formatMessage({ id: "PAYMENT.CREDIT" })}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                style={{ minWidth: "70px" }}
                                as="lable"
                            >
                                {paymentObject.credit}
                            </FormControl>
                            <InputGroup.Append>
                                <InputGroup.Text style={{ minWidth: "90px" }}>{"ریال"}</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </div> */}


                    {/* <div className="col-lg-6 form-group fv-plugins-icon-container">
                        <button
                            type="button"
                            onClick={backToObjectsList}
                            className="btn btn-light float-right"
                        >
                            <i className="fa fa-arrow-left"></i>
                            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONBACK" })}
                        </button>
                    </div> */}
                </CardBody>
            </Card>
        </>
    );
}

export default PaymentResultPage

